import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { graphql } from "../../__generated__/gql";
import { useMutation } from "urql";
import urls from "../../routes";
import { useEffect } from "react";
import { useToast } from "../../ui/Toast/ToastContext";
import Loader from "../../ui/Loader/Loader";

const SetupWebflowConnectionMutation = graphql(/* GraphQL */ `
  mutation setupWebflowConnection($input: SetupWebflowConnectionInput!) {
    setupWebflowConnection(input: $input) {
      id
    }
  }
`);

function WebflowOauthCallback() {
  const { showToast } = useToast();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [, setupWebflowConnection] = useMutation(
    SetupWebflowConnectionMutation,
  );

  const code = searchParams.get("code");

  useEffect(() => {
    async function setup() {
      if (!code) {
        return navigate(urls.publishing.connections.root);
      }

      const response = await setupWebflowConnection({
        input: { code },
      });

      if (response.error) {
        showToast({ title: "Something went wrong" });
      } else {
        showToast({ title: "Webflow connected" });
      }

      return navigate(urls.publishing.connections.webflow);
    }

    void setup();
  }, [code, navigate, setupWebflowConnection, showToast]);

  if (!code) {
    return <Navigate to={urls.publishing.connections.root} />;
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
}

export default WebflowOauthCallback;
